export const formatCurrency = (amount) => {
    const val = parseFloat(amount || 0);
    return `${val.toFixed(3)} JOD`;
};
